import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to download the invoice
export const downloadInvoice = createAsyncThunk(
  'invoice/download',
  async (orderId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No token found in localStorage');

      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/invoices/generate/${orderId}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: token,
        },
      });

      // Create a blob and URL for downloading
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);

      return { url, orderId };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState: {
    downloading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadInvoice.pending, (state) => {
        state.downloading = true;
        state.error = null;
      })
      .addCase(downloadInvoice.fulfilled, (state, action) => {
        state.downloading = false;

        // Trigger the download in the browser
        const link = document.createElement("a");
        link.href = action.payload.url;
        link.setAttribute("download", `invoice-${action.payload.orderId}.pdf`);
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(action.payload.url);
      })
      .addCase(downloadInvoice.rejected, (state, action) => {
        state.downloading = false;
        state.error = action.payload;
      });
  },
});

export default invoiceSlice.reducer;
